import { FallbackProps } from "react-error-boundary";
import { ErrorMessage } from "../../components/ErrorMessage/ErrorMessage";

export default function ErrorFallbackComponent(props: FallbackProps) {
  const { error, resetErrorBoundary } = props;
  return (
    <div className="app">
      <main className="">
        <ErrorMessage handleError={resetErrorBoundary} error={error} />
      </main>
    </div>
  );
}
